// start:ng42.barrel
import './person-picker-popup.controller';
// end:ng42.barrel

